import { ReportingDialogOddComponent } from '@reporting/components/reporting-dialog-odd/reporting-dialog-odd.component';

import { ReportingChartComponent } from './reporting-chart/reporting-chart.component';
import { ReportingLineChartComponent } from './reporting-chart-line-chart/reporting-chart-line-chart.component';
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component';
import { ReportingDataTableComponent } from './reporting-data-table/reporting-data-table.component';
import { ReportingDepositsComponent } from './reporting-deposits/reporting-deposits.component';
import { ReportingDialogGreennessComponent } from './reporting-dialog-greenness/reporting-dialog-greenness.component';
import { ReportingDisclaimerComponent } from './reporting-disclaimer/reporting-disclaimer.component';
import { ReportingHeaderComponent } from './reporting-header/reporting-header.component';
import { ReportingTechnicalIssueComponent } from './reporting-technical-issue/reporting-technical-issue.component';
import { ReportingTransactionSectionComponent } from './reporting-transaction-section/reporting-transaction-section.component';
import { ReportingTransactionsComponent } from './reporting-transactions/reporting-transactions.component';

export const components = [
  ReportingDisclaimerComponent,
  ReportingChartComponent,
  ReportingLineChartComponent,
  ReportingDashboardComponent,
  ReportingDataTableComponent,
  ReportingDepositsComponent,
  ReportingHeaderComponent,
  ReportingTechnicalIssueComponent,
  ReportingTransactionSectionComponent,
  ReportingTransactionsComponent,
  ReportingDialogOddComponent,
  ReportingDialogGreennessComponent
];

export { ReportingLineChartComponent } from './reporting-chart-line-chart/reporting-chart-line-chart.component';
export { ReportingChartComponent } from './reporting-chart/reporting-chart.component';
export { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component';
export { ReportingDataTableComponent } from './reporting-data-table/reporting-data-table.component';
export { ReportingDepositsComponent } from './reporting-deposits/reporting-deposits.component';
export { ReportingDisclaimerComponent } from './reporting-disclaimer/reporting-disclaimer.component';
export { ReportingHeaderComponent } from './reporting-header/reporting-header.component';
export { ReportingTechnicalIssueComponent } from './reporting-technical-issue/reporting-technical-issue.component';
export { ReportingTransactionSectionComponent } from './reporting-transaction-section/reporting-transaction-section.component';
export { ReportingTransactionsComponent } from './reporting-transactions/reporting-transactions.component';
export { ReportingDialogOddComponent } from '@reporting/components/reporting-dialog-odd/reporting-dialog-odd.component';
export { ReportingDialogGreennessComponent } from './reporting-dialog-greenness/reporting-dialog-greenness.component';
